import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {NovoAtendimento} from "../../../modules/cadastro/models/novo-atendimento";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TipoDocumentoCliente} from "../../../modules/cadastro/gerais/models/tipo-documento-cliente";
import {AtendimentoService} from "../../../modules/cadastro/services/atendimento.service";
import {Router} from "@angular/router";
import {CadastrosGeraisService} from "../../../modules/cadastro/services/cadastros-gerais.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {Cliente} from "../../../modules/cadastro/cliente/models/cliente";
import {ClienteService} from "../../../modules/cadastro/services/cliente.service";
import {AuthService} from "../../../modules/auth/services/auth-service";
import {Token} from "../../../modules/auth/models/token";
@Component({
  selector: 'app-cadastro-novo-atendimento',
  standalone: false,
  templateUrl: './cadastro-novo-atendimento.component.html',
  styleUrl: './cadastro-novo-atendimento.component.css'
})
export class CadastroNovoAtendimentoComponent {
  @Input() showModal = false;
  @Input() statusInicial: string = '';
  @Output() atualizarLista = new EventEmitter<void>();
  @Output() fecharModalPai = new EventEmitter<void>();

  novoAtendimento = new NovoAtendimento();
  formCadastrar: FormGroup;
  listaTipoDocumento: TipoDocumentoCliente[];
  clientes: Cliente[] = [];
  token = new Token();

  constructor(private atendimentoService: AtendimentoService,
              private clienteService: ClienteService,
              private authService: AuthService,
              private formBuilder: FormBuilder,
              private router: Router,
              private geraisService: CadastrosGeraisService,
              private toastr: ToastrService) {
    this.construirFormulario();
    this.token = authService.AccessToken || new Token();
    this.listarClientes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statusInicial']) {
      this.formCadastrar.controls['status'].setValue(this.statusInicial);
    }

    // Quando o modal for aberto, atualiza a listagem de clientes
    if (changes['showModal'] && changes['showModal'].currentValue === true && changes['showModal'].previousValue !== true) {
      this.listarClientes();
    }
  }


  salvar(){
    this.validarFormulario();
    if(this.formCadastrar.invalid){
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }

    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        this.preencherModelo();
        this.atendimentoService.adicionar(this.novoAtendimento).subscribe(
          (response) => {
            if (response.sucesso) {
              this.toastr.success("Lead salvo com sucesso");
              this.fecharModal();
            } else {
              this.toastr.error("Erro ao salvar Lead - " + response.errors[0].mensagem);
            }
          },
          (error) => {
            if(error.status === 500){
              this.toastr.error(error.error);
            }
            this.toastr.error(error.erros[0].mensagem);
          }
        );
      }
    });
  }

  fecharModal(){
    this.formCadastrar.reset();
    this.showModal = false;
    this.fecharModalPai.emit();
  }

  onBackgroundClick(event: Event): void {
    this.fecharModal();
  }


  private validarFormulario(){
    Object.keys(this.formCadastrar.controls).forEach(name => {
      const control = this.formCadastrar.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  private preencherModelo(){
    this.novoAtendimento.descricaoInicial = this.formCadastrar.controls['descricaoInicial'].value;
    this.novoAtendimento.descricao = this.formCadastrar.controls['descricao'].value;
    this.novoAtendimento.pessoaId = this.formCadastrar.controls['solicitante'].value;
    this.novoAtendimento.descricao = this.formCadastrar.controls['descricao'].value;
    this.novoAtendimento.tipoGerado = this.formCadastrar.controls['tipoGerado'].value;

    const valorPotencialStr = this.formCadastrar.controls['valorPotencial'].value;
    this.novoAtendimento.valorPotencial = parseFloat(valorPotencialStr);
    this.novoAtendimento.status = this.formCadastrar.controls['status'].value;
  }

  private construirFormulario(){
    this.formCadastrar = this.formBuilder.group({
      descricaoInicial: ['', [Validators.required, Validators.maxLength(200)]],
      solicitante: [0],
      descricao: ['', [Validators.required]],
      tipoGerado: [this.novoAtendimento.tipoGerado],
      valorPotencial: [this.novoAtendimento.valorPotencial],
      status: [this.statusInicial || '', [Validators.required]]
    });
  }

  private listarClientes(){
    if(this.token.seguranca.toUpperCase().includes("ADMIN")){
      this.clienteService.selecionarListaPorOrigem().subscribe(retorno => {
        if(retorno.sucesso){
          this.clientes = retorno.dados;
        }
      });
    }else{
      this.clienteService.selecionarListaPorResponsavel().subscribe(retorno => {
        if(retorno.sucesso){
          this.clientes = retorno.dados;
        }
      })
    }
  }
}
